import React from 'react';
import {Statistic, Row, Col, Divider, message, Spin} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import CountriesTable from './../components/country.table';
import * as Actions from "./../containers/qr/actions";
import * as C from './../containers/qr/constants';

const mapStateToProps = state => ({
    answer: state.QrReducer,
});

const mapDispatchProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

// render dashboard
class IndexController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true, // loading data from server
            total: 0,
            totalToday: 0,
            list: [],
        };
    }

    componentDidMount() {
        this.props.actions.LoadStats();
    }

    componentWillReceiveProps(p) {
        if (p.answer && p.answer.data) {
            switch (p.answer.state) {
                case C.QR_STATS_START:
                    this.setState({isLoading: true});
                    break;
                case C.QR_STATS_FINISH:
                    const data = p.answer.data && p.answer.data.data ? p.answer.data.data : {};
                    this.setState({
                        isLoading: false,
                        total: data.total || 0,
                        totalToday: data.total_today || 0,
                        list: data.country || [],
                    });
                    break;
                case C.QR_STATS_ERROR:
                    this.setState({
                        isLoading: false,
                    });
                    message.error(`Error load stats`);
                    break;
                default: break;
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <Spin spinning={this.state.isLoading}>
                    <Row>
                        <Col span={12}>
                            <Statistic title="Total users redirects" value={this.state.total}/>
                        </Col>
                        <Col span={12}>
                            <Statistic title="Today redirects" value={this.state.totalToday}/>
                        </Col>
                    </Row>
                    <Divider>Users by countries</Divider>
                    <Row>
                        <CountriesTable
                            loading={false}
                            list={this.state.list}
                        />
                    </Row>
                </Spin>
            </React.Fragment>
        );
    }
}


IndexController.propTypes = {
    actions: PropTypes.instanceOf(Object).isRequired,
    answer: PropTypes.instanceOf(Object).isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchProps
)(IndexController);



// WEBPACK FOOTER //
// ./src/controllers/Index.controller.js